import React, { useState } from 'react';
import Upload, { UploadProps } from 'rc-upload';
import ReactLoading from 'react-loading';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { toast } from 'react-toastify';
// import { IS_DEV, IS_DAILY } from '@/constants/env';
import styles from './index.module.scss';
// const defaultAction = `${
//   IS_DEV || IS_DAILY ? 'https://api-next-staging.cbndata.com' : 'https://api-next.cbndata.com'
// }/consumerstation/admin/content/file`;

export interface BaseUploadProps extends UploadProps {
  value?: string;
  limit?: {
    size?: number;
    width?: number;
    height?: number;
    suffix?: string[];
  };
  accept?: string;
  onChange?: (value: any) => any;
}

const getFileNameData = (fileFullName?: string) => {
  if (!fileFullName) return {};
  const fileNameArr = fileFullName.split('.');
  const fileType = fileNameArr[fileNameArr.length - 1];
  fileNameArr.pop();
  let fileName: any = fileNameArr.join('.');
  fileName = fileName.split('/');
  fileName = fileName[fileName.length - 1];
  return { fileType, fileName };
};

// const imgSuffix = ['jpg', 'png', 'jpeg', 'bmp', 'webp'];

// 预留value和onChange，以支持放在ProForm.Item和Form.Item里面
// 在Item使用属性getValueFromEvent来取值
// 传值结构为string和string[],string为图片地址
const BaseUpload: React.FC<BaseUploadProps> = ({ value, onChange, limit, accept, children, ...rest }) => {
  const { token } = useSelector<any>(state => state.user) as any;
  const [file, setFile] = useState<any>(value);
  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const _onChange = (e: any) => {
    console.log('e :>> ', e);
    const reader = new FileReader();
    reader.readAsDataURL(e);
    reader.onloadend = val => {
      console.log('imgUrl :>> ', val.target.result);
      setFile(val.target.result);
      onChange({ url: val.target.result || '', name: e.name });
    };
    // if (e.code === 200) {
    //   setFile(e?.data?.filePath);
    //   setLoading(false);
    // }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const _beforeUpload = async file => {
    const fileNameData = getFileNameData(file.name);
    const fileType = fileNameData.fileType || '';

    if (limit?.suffix && limit.suffix.length) {
      const fixSuffixList = limit.suffix.map(item => item.toLowerCase());
      const isValid = fixSuffixList.includes(fileType.toLowerCase());
      if (!isValid) {
        // message.error(`请选择 ${limit.suffix.join('/')} 格式!`);
      }
    }

    if (limit?.size) {
      const isOverly = file.size / 1024 / 1024 > limit.size;
      if (isOverly) {
        // message.error(`文件大小需限制在${limit?.size}M以下.`);
      }
    }
    _onChange(file);
    return false;
  };

  const _onProgress = () => {
    setLoading(true);
  };

  const _onError = () => {
    toast.error('上传失败');
    setLoading(false);
  };

  return (
    <>
      {file ? (
        <div className={styles.imgPreview}>
          <img className={styles.imgPreviewImg} src={file} />
          <svg className={styles.delete} aria-hidden="true" color="#d8d8d8" onClick={() => setFile('')}>
            <use xlinkHref="#icon-cancel" />
          </svg>
        </div>
      ) : (
        <Upload
          className={styles.upload}
          name="file"
          withCredentials={false}
          beforeUpload={_beforeUpload}
          onSuccess={_onChange}
          onProgress={_onProgress}
          onError={_onError}
          accept={accept}
          // action={defaultAction}
          headers={{
            Authorization: token || '',
          }}
          {...rest}
        >
          <div className={styles.container}>
            {children}
            {loading && (
              <div className={classNames('flex-row-nowrap', 'flex-center-center', styles.loading)}>
                <ReactLoading
                  type="spinningBubbles"
                  width="20px"
                  height="20px"
                  color="#000"
                  className={styles.loadingImg}
                />
              </div>
            )}
          </div>
        </Upload>
      )}
    </>
  );
};

export default BaseUpload;
